<span>{{ 'Conversation::BatchTaggingStartedMessage' | abpLocalization: tagNames }}</span>
